import { newToolFilterOAuthMcp } from "../oauth.ts";

export const neonMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://neon.com/apple-touch-icon.png",
  url: "https://mcp.neon.tech/mcp",
  label: "Neon",
});
